import React from 'react';
import CoreCheckbox from '@components-clean/core/core-checkbox';

const CheckboxesPage = ({ isDisabled }: { isDisabled: boolean }) => (
    <>
        <CoreCheckbox label="Unchecked state" disabled={isDisabled} data-testid="unchecked-checkbox" />
        <br />
        <CoreCheckbox defaultChecked label="Checked state" disabled={isDisabled} data-testid="checked-checkbox" />
        <br />
        <CoreCheckbox
            value={null}
            label="Indeterminate state"
            disabled={isDisabled}
            data-testid="indeterminate-checkbox"
        />
        <br />
        <CoreCheckbox
            alternativeStyle
            label="Secondary - Unchecked state"
            disabled={isDisabled}
            data-testid="secondary-unchecked-checkbox"
        />
        <br />
        <CoreCheckbox
            alternativeStyle
            defaultChecked
            label="Secondary - Checked state"
            disabled={isDisabled}
            data-testid="secondary-checked-checkbox"
        />
        <br />
        <CoreCheckbox
            alternativeStyle
            value={null}
            label="Secondary - Indeterminate state"
            disabled={isDisabled}
            data-testid="secondary-indeterminate-checkbox"
        />
    </>
);

export default CheckboxesPage;
